/** Zero-render component that publishes the router's navigate fn to the bridge. */
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { setBridgeNavigate } from './navigationBridgeRef';

/**
 * Mount once inside the router to connect React Router's navigate fn to the
 * module-level bridge, enabling non-React code to trigger navigation.
 */
export function NavigationBridge(): null {
  const navigate = useNavigate();
  useEffect(() => {
    setBridgeNavigate((path: string) => navigate(path));
    return () => setBridgeNavigate(null);
  }, [navigate]);
  return null;
}
